export const controls = [
  {
    name: 'optionLowercase',
    label: 'Include Lowercase Letters',
    pattern: 'a',
    checked: true
  },
  {
    name: 'optionUppercase',
    label: 'Include Uppercase Letters',
    pattern: 'A',
    checked: false
  },
  {
    name: 'optionNumerical',
    label: 'Include Numbers',
    pattern: '0',
    checked: false
  },
  {
    name: 'optionSpecial',
    label: 'Include Symbols',
    pattern: '!',
    checked: false
  }
];